// extracted by mini-css-extract-plugin
module.exports = {"heading":"press-award-section_heading__myjIh","awards":"press-award-section_awards__2tmy6"};